var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownCircleOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.49 15.51 -1.96264e-07 10 -4.37114e-07C4.49 -6.77964e-07 -1.96264e-07 4.49 -4.37114e-07 10C-6.77964e-07 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10ZM9.47 12.79L5.94 9.26C5.79 9.11 5.72 8.92 5.72 8.73C5.72 8.54 5.79 8.35 5.94 8.2C6.23 7.91 6.71 7.91 7 8.2L10 11.2L13 8.2C13.29 7.91 13.77 7.91 14.06 8.2C14.35 8.49 14.35 8.97 14.06 9.26L10.53 12.79C10.24 13.09 9.76 13.09 9.47 12.79Z",
    fill: "#A5ABDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCircleOutlined);
export default __webpack_public_path__ + "static/media/down-circle-outlined.f5060d37e99477346a97c57d5d89140d.svg";
export { ForwardRef as ReactComponent };